var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.2994,
    y: 0.876404,
    width: 24,
    height: 24,
    transform: "rotate(45 17.2994 0.876404)",
    fill: "url(#pattern0_3345_352)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3345_352",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3345_352",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3345_352",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADFSURBVHgB7ZZBDsMgDARNH9mH0Hekv8w9vVdyi7QHikgFa0x7YKU9RJG9kyAsiywt/atU9ZosRlF9ULTDNyGVarM+VYhLQ5/IQKAmCqt3g5jRd/2J4suTORAGYlg4AzE8vAfCLbwFwj38G8S08BOIA54TXkCk4Cd8sOEtg6imAJ89+6k48wdsHttM+I6joCemOTx75wvRctXcILTjng+HUGLIDINQw4QzQ+jnRkRNuAoEvRFtIYS7dAo1m7DSXy6lS0sz9QK/33ZFA0mihAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.30c7610d5fe8b00227d9f7c2102e7481.svg";
export { ForwardRef as ReactComponent };